import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';
import { readOnly, writeOnlyRoutes } from '../config/readOnly';

Vue.use(VueRouter);

export const router = new VueRouter({
    mode: 'history',
    routes
})

if (readOnly) {
    router.beforeEach((to, from, next) => {
        if (writeOnlyRoutes.includes(to.name)) {
            return next(localStorage.getItem('ship_token') ? { name: 'home' } : { name: 'login' });
        }

        next();
    });
}
